import { createTestIds } from '../../utils';
import { elements } from '../FormField/FormField.test-ids';

export const getCurrencyInputTestIds = createTestIds('currency-input', [
  'control',
  ...elements
] as const);
